import { Image } from '@/components/Image'
import { BodyM } from '@/components/Typography'

import { IconListItemContainer } from './styles'

interface IconListItemProps {
  imageSrc: string
  label: string
}

export const IconListItem = ({ imageSrc, label }: IconListItemProps) => (
  <IconListItemContainer>
    <Image source={imageSrc} width={98} height={98} alt="" />
    <BodyM light="solid">{label}</BodyM>
  </IconListItemContainer>
)
